import { SubscriptionState } from '../enums/subscription-state';

export const FreePlanSubscriptionStates = [SubscriptionState.expired];
